import React, { useState } from 'react';
import { Booking } from '../../../models/booking';
import { useNavigate } from 'react-router-dom';
import { AppContext } from "../../../services/AppContext";
import { dateFormat } from '../common/dateUtils';
import { paymentStatusColor, carColor, statusColor } from '../common/bookingUtils';
import { InfoOutlined, StarBorder, ElectricCar, ChevronRight } from '@mui/icons-material';
import "../../../../styles/commonStyle.css"
import GiveFeedBackRating from "../fields/GiveFeedBackRating"
import { useMediaQuery, useTheme } from '@mui/material';

interface Props {
  bookings: Booking[];
}

const BookingItemShortCompleted: React.FC<Props> = ({ bookings }) => {
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [showRatingModal, setShowRatingModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState<Booking | null>(null);

  const handleClick = (booking: Booking) => {
    AppContext.setBooking(booking);
    navigate("/userBookingDetailsReadOnly", { state: { booking } });
  };
  const handleRateClick = (e: React.MouseEvent, booking: Booking) => {
    e.stopPropagation();
    setSelectedBooking(booking);
    setShowRatingModal(true);
  };


  if (bookings.length === 0) {
    return (
      <div className="cardNoRides">
        <div className="noRidesIcon">
          <InfoOutlined fontSize='large' style={{ color: '#6c757d' }} />
        </div>
        <h5 className="fw-bold text-dark mb-1">No Past Rides</h5>
        <p className="text-muted mb-0 customText">
          Looks like you haven’t completed any rides yet.
      </p>
      </div>
    );
  }


  return (
    <>
      <div className="container my-4">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-9 px-0">
            {bookings.map((booking) => (
              <React.Fragment key={booking.bookingId}>
                {isMobile ? (
                  <div
                    className="shadow-sm mb-2 bg-white d-flex align-items-center px-3 py-2 border-top border-bottom rounded-0"
                    style={{
                      width: '100vw',
                      marginLeft: '-12px',
                      marginRight: '-12px',
                      cursor: 'pointer'
                    }}
                    onClick={() => handleClick(booking)}
                  >

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <ElectricCar className="me-2 textGreen" fontSize="small" />
                      <div className="text-start">
                        <div className="fw-bold">
                          {booking.fromCity} → {booking.toCity}
                        </div>
                        <div className="customTextXs" style={{ color: '#666' }}>
                          {booking.selectedCarModel}
                        </div>
                        {/* {booking.status === "CANCELLED" ? (
                          <div className="customTextXs" style={{ color: '#d32f2f' }}>
                            Cancelled
                          </div>
                        ) : (
                            <div className="customTextXs textGreen" >
                              Completed on {dateFormat(booking.ride.endTime)}
                            </div>
                          )} */}

                        <div className="text-muted small">Booking ID: {booking.bookingId}</div>
                      </div>
                    </div>


                    <div className="ms-auto d-flex flex-column align-items-end">
                      <div className={`fw-semibold small ${booking.status === "CANCELLED" ? "text-danger" : "text-success"}`} >
                        {booking.status}
                      </div>
                      <ChevronRight style={{ color: '#888' }} />
                      {booking.status !== "CANCELLED" &&
                        <button
                          className="btn btn-success btn-sm mt-1 d-flex align-items-center gap-1 customTextXs py-1 px-2"
                          onClick={(e: any) => {
                            e.stopPropagation();
                            handleRateClick(e, booking);
                          }}
                        >
                          <StarBorder className="customText" />
                        Rate Ride
                        </button>
                      }
                    </div>
                  </div>
                ) : (
                    <div className="card border shadow-sm mb-4" style={{ cursor: 'pointer' }}
                      onClick={() => handleClick(booking)}
                    >
                      <div className="position-relative p-4 border-bottom"
                        style={{ boxShadow: '0 4px 8px rgba(0,0,0,0.06)' }}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <h6 className="mb-1 ms-2 d-flex align-items-center gap-2">
                              <ElectricCar fontSize="small" style={{ color: booking.status === "CANCELLED" ? "#888" : '#388e3c' }} />
                              <strong style={{ color: booking.status === "CANCELLED" ? "#888" : '#388e3c' }}>
                                {booking.fromCity} → {booking.toCity}
                              </strong>
                              <span className="badge fw-semibold px-2 py-1 customTextXs"
                                style={{
                                  backgroundColor: booking.status === "CANCELLED" ? "#ccc" : '#e3f2fd',
                                  color: booking.status === "CANCELLED" ? "#fff" : '#0d47a1'
                                }}>
                                {dateFormat(booking.bookingDate)}
                              </span>
                            </h6>
                            <div className="text-muted small ms-2">
                              <small className="d-flex flex-wrap align-items-center gap-2">
                                <span className="badge border fw-semibold px-2 py-1" style={{ fontSize: '0.65rem', color: '#455a64' }}>
                                  {booking.returnRide ? "Return" : "OneWay"}
                                </span>
                                <span>&bull;</span>
                                <strong style={{ color: statusColor(booking) }}>
                                  {booking.status}
                                </strong>
                                <span>&bull;</span>
                                <strong >
                                  ID: {booking.bookingId}
                                </strong>
                              </small>
                            </div>
                          </div>
                          {booking.status !== "CANCELLED" &&
                            <button
                              className="btn btn-success btn-sm mt-1 d-flex align-items-center gap-1 customTextXs py-1 px-2"
                              onClick={(e: any) => {
                                e.stopPropagation();
                                handleRateClick(e, booking);
                              }}
                            >
                              <StarBorder className="customText" />
                               Rate Ride
                            </button>
                          }
                        </div>
                      </div>

                      <div className="p-4">
                        <div className="row g-4">
                          <div className="col-md-4 text-start">
                            <div className="text-uppercase text-muted small mb-1">Pickup</div>
                            <div className="small text-muted fw-semibold">{booking.fromAddress}</div>
                          </div>
                          <div className="col-md-4 text-start">
                            <div className="text-uppercase text-muted small mb-1">Drop</div>
                            <div className="small text-muted fw-semibold">{booking.toAddress}</div>
                          </div>
                          <div className="col-md-4 text-start">
                            <div className="text-uppercase text-muted small mb-1">Fare / Distance</div>
                            <div className="small text-muted fw-semibold">
                              ₹{booking.payment?.totalFare ?? '-'} / {booking.totalDistance ?? '-'} km
                    </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      {
        showRatingModal && selectedBooking && (
          <>
            <GiveFeedBackRating showRatingModal={showRatingModal} setShowRatingModal={setShowRatingModal} booking={selectedBooking} />
          </>
        )
      }


    </>
  );
};

export default BookingItemShortCompleted; 